import { createContext, useContext } from 'react';

import type { Softphone } from './use-whatsapp-call';

/**
 * The one softphone, owned by the widget root (so a call outlives the chat
 * view) and read by the chat header's call button.
 */
export const SoftphoneContext = createContext<Softphone | null>(null);

export const useSoftphone = (): Softphone => {
  const softphone = useContext(SoftphoneContext);
  if (!softphone) throw new Error('useSoftphone must be used inside the WhatsApp widget.');
  return softphone;
};
